import React from 'react';
import './Footer.scss';

/**
 * Composant Footer : Pied de page contenant les informations de contact, adresse, horaires et bouton RDV.
 */
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Colonne 1 : Identité & Adresse */}
        <div className="footer-column">
          <h3 className="footer-title">Marie Guennec</h3>
          <p className="footer-subtitle">PSYCHOLOGUE – NEUROPSYCHOLOGUE</p>
          <address className="footer-address">
            Espace santé<br />
            2A Boulevard du Bois Jacques<br />
            44830 Bouaye
          </address>
        </div>

        {/* Colonne 2 : Contact & Réservation */}
        <div className="footer-column">
          <h4 className="footer-heading">CONTACT & RDV</h4>
          <a 
            href="https://www.ibookthedate.fr/psychologue/44830-bouaye/marie-guennec" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-rdv"
          >
            Prendre rendez-vous
          </a>
          <p className="footer-contact-info">
            <strong>Email :</strong> <a href="mailto:mguennec.neuropsy@gmail.com">mguennec.neuropsy@gmail.com</a>
          </p>
          <p className="footer-contact-info">
            <strong>Tél :</strong> <a href="tel:0600000000">06 50 62 79 49</a>
          </p>
        </div>

        {/* Colonne 3 : Horaires */}
        <div className="footer-column">
          <h4 className="footer-heading">HORAIRES</h4>
          <ul className="footer-schedule">
            <li><span>Mardi :</span> 9h – 19h</li>
            <li><span>Mercredi :</span> 9h – 19h</li>
            <li><span>Vendredi :</span> 9h – 19h</li>
            <li><span>Samedi :</span> 9h – 18h</li>
          </ul>
          <p className="footer-appointment-note">Sur rendez-vous uniquement</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Marie Guennec. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;